import { render, staticRenderFns } from "./CounselorIndex.vue?vue&type=template&id=a5058f5e&style=height%3A%20100%25%3B"
import script from "./CounselorIndex.vue?vue&type=script&lang=js"
export * from "./CounselorIndex.vue?vue&type=script&lang=js"
import style0 from "./CounselorIndex.vue?vue&type=style&index=0&id=a5058f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports